module.exports = __webpack_public_path__ + "assets/measure_trip_events.31c98256.svg";